import { AppStateResolver } from './app-state.resolver'

export const APP_RESOLVER_PROVIDERS = [AppStateResolver]



// WEBPACK FOOTER //
// ./src/app/app.resolver.ts